import { initAnalytics } from './analytics';
import { COOKIE_CONSENT_REQUIRED_FOR_ANALYTICS } from './analytics/consentFeatureFlags';
import { getAnalyticsUserOptOut } from './analytics/analyticsGate';
import { isConsentAccepted } from './analytics/consentStore';
import { injectGaConsentDefaults, grantGaConsent } from './analytics/providers/googleAnalytics';
import { runAfterPageInteractive } from './runAfterPageInteractive';
import { initSentry } from './sentry';

let scheduled = false;

/** Defer Sentry and analytics until after LCP / first input to protect LCP and TBT. */
export function scheduleNonCriticalStartup(): void {
  if (scheduled) return;
  scheduled = true;

  runAfterPageInteractive(() => {
    initSentry();

    injectGaConsentDefaults();

    const allowAnalyticsInit =
      !getAnalyticsUserOptOut() &&
      (!COOKIE_CONSENT_REQUIRED_FOR_ANALYTICS || isConsentAccepted());

    if (allowAnalyticsInit) {
      if (COOKIE_CONSENT_REQUIRED_FOR_ANALYTICS) {
        grantGaConsent();
      }
      initAnalytics();
    }
  });
}
